import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index.vue'
import download from '@/components/download.vue'
import contactUs from '@/components/contactUs.vue'

Vue.use(Router)

export default new Router({
  routes: [{
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/download',
      name: 'download',
      component: download
    },
    {
      path: '/contactUs',
      name: 'contactUs',
      component: contactUs
    }
  ]
})


// WEBPACK FOOTER //
// ./src/router/index.js